import type LocationSourceType from 'owa-service/lib/contract/LocationSourceType';

export enum LocationMetricType {
    String = 1,
    Enhanced,
    None,
}

export interface LocationMetricTypesData {
    locationTypeGuidedCapture: LocationMetricType;
}

export interface LocationMetricInfo {
    selectionSource: LocationSelectionSource | null;
    TotalLength?: number;
    TotalDigits?: number; // used to identify phone numbers
    locationSource: LocationSourceType;
    locationEntityType?: string;
    relevanceHint?: string;
    locationIndex?: number;
    queryLength?: number;
    isOfficeLocation?: boolean;
    isUrlLocation?: boolean;
}

export declare type LocationSelectionSource =
    | 'ExplicitTyping'
    | 'ExistingLocation'
    | 'LocationWell'
    | 'RoomPanel'
    | 'RoomPanelInSA'
    | 'RoomPicker'
    | 'Other';
